import {
  REGIONS_REQUEST, REGIONS_SUCCESS, REGIONS_FAILURE
} from '../actions/region'

const regions = (state = { isFetched: false, isFetching: false, items: [] }, action) => {
  switch (action.type) {
    case REGIONS_REQUEST:
      return Object.assign({}, state, { isFetching: true })

    case REGIONS_SUCCESS:
      return Object.assign({}, state, { isFetched: true, isFetching: false, items: action.items, errorMessage: '' })

    case REGIONS_FAILURE:
      return Object.assign({}, state, { isFetching: false, items: [], errorMessage: action.message })

    default:
      return state
  }
}

export default regions
